import { useSelector } from 'react-redux'
import { ReactComponent as MiniDivisionBadge } from '../../../../assets/images/common/icons/mini-division-badge.svg'
import { ReactComponent as StandaloneLogo } from '../../../../assets/images/common/icons/standalone-logo.svg'
import { ReactComponent as ScissorsRegular } from '../../../../assets/images/common/icons/scissors-regular.svg'
import scorecardsBack from '../../../../assets/images/events/scorecards-back.webp'
import { getMomentInCommunityTimezoneReversed } from '../../../../utility/datesHelper'
import { yardageByLevel } from '../../../../utility/curriculumHelper'
import { splitArray } from '../../../../utility/arrayHelper'
import moment from 'moment'

import classes from './Scorecards.module.scss'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const Scorecards = ({ printOptions }) => {
  const timezone = useSelector(state => state.user.current_user.communities[0].timezone)
  const event = useSelector(state => state.nineHoleEvent)
  const startTime = getMomentInCommunityTimezoneReversed(moment(event.eventDate), timezone)

  const filteredStudents = event.students
    .filter((s) => !!s.pairingGroupId)
    .toSorted((a, b) =>
      a.pairingGroupOrder - b.pairingGroupOrder
    )

  const pagedStudents = splitArray(filteredStudents, 3)

  return (
    <div id='scorecards' className={classes.scorecards}> {
      pagedStudents.map((userGroup, index) => (
        <div key={index}>
          <div className='ScoreCardsPage'>
            {userGroup.map((student) => {
              const group = event.pairings.pairingGroups.find((group) => group.id === student.pairingGroupId)
              return (
                <div key={student.id} className={(classNames('scorecard', classes.scorecard))}>
                  <div className={classes.leftSide}>
                    <div className='py-2'>
                      {startTime.format('MMM D, YYYY h:mma')} - {startTime.clone().add(1, 'hours').format('h:mma')}
                    </div>

                    <div className={classes.scorecardHeader}>
                      <p className={classes.time}>Time</p>
                      <p className={classes.hole}>Starting Hole</p>
                      <p className={classes.yardage}>Yardage</p>
                      <p className={classes.player}>Player Name</p>
                      <p className={classes.playerSignature}>Player signature</p>
                      <p>Partner signature</p>
                    </div>

                    <div className={classes.scorecardInfo}>
                      <p className={classes.time}>{moment(group?.startTime, timezone).format('LT')}</p>
                      <p className={classes.hole}>
                        {`${group.startHole.value || ''} ${group.playersGroup.value || ''}`}
                      </p>
                      <p className={classes.yardage}>
                        {student.level < 6 ? yardageByLevel[student.level] / 9 + ' yds' : 'Full Tee Box'}
                      </p>
                      <div className={classes.studentInfo}>
                        <div className={classes.studentLevel}>
                          <MiniDivisionBadge />
                          <div className={classes.level}>{student.currentFormalDivision}</div>
                        </div>
                        <p>{student.firstName} {student.lastName}</p>
                      </div>
                      <div className={classes.signature}>
                        <div className={classes.rectangle}/>
                      </div>
                      <div className={classes.signature}>
                        <div className={classes.rectangle}/>
                      </div>
                    </div>

                    <table>
                      <thead>
                        <tr className={classes.slateGrayRow}>
                          <th className={classes.hole}>HOLE</th>
                          <th>1</th>
                          <th>2</th>
                          <th>3</th>
                          <th>4</th>
                          <th>5</th>
                          <th>6</th>
                          <th>7</th>
                          <th>8</th>
                          <th>9</th>
                          <th className={classes.total}>TOTAL</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className={classes.myScoreRow}>
                          <td className={classes.rowLabel}>MY SCORE</td>
                          <td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
                        </tr>
                        <tr>
                          <td className={classes.rowLabel}>Green In Regulation</td>
                          <td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
                        </tr>
                        <tr>
                          <td className={classes.rowLabel}>Total Putts</td>
                          <td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
                        </tr>
                        <tr className={classes.slateGrayRow}>
                          <td className={classes.rowLabel}>Putts &lt; 4ft</td>
                          <td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
                        </tr>
                        <tr className={classes.slateGrayRow}>
                          <td className={classes.rowLabe}>1st Putt Distance</td>
                          <td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
                        </tr>
                      </tbody>
                    </table>

                    <div className={classes.girWrapper}>
                      <div className={classes.girSimpleItem}>
                        <span className={classNames(classes.gir, 'pull-right')}>GIR</span>
                      </div>

                      <div className={classes.girSimpleItem}>
                        <span className={classes.girText}>What is my Green in Regulation?</span>
                      </div>

                      <div className={classes.girItem}>
                        <div className={classes.rightArrow}/>
                        <div className={classes.girItemBox}>
                          <span >Level 1 - 5</span>
                          <span className={classes.girMinText}>(25-2000 yards)</span>
                        </div>
                      </div>

                      <div className={classes.girItem}>
                        <div className={classes.rightArrow}/>
                        <div className={classes.girItemBox}>
                          <span >2 Shots</span>
                          <span className={classes.girMinText}>Hit green in 2 shots or less</span>
                        </div>
                      </div>


                      <div className={classes.girItem}>
                        <div className={classes.rightArrow}/>
                        <div className={classes.girItemBox}>
                          <span >Level 6-10</span>
                          <span className={classes.girMinText}>Tee box</span>
                        </div>
                      </div>

                      <div className={classes.girItem}>
                        <div className={classes.rightArrow}/>
                        <div className={classes.girItemBox}>
                          <span className={classes.girMinText}>PAR 3 - 1 SHOT</span>
                          <span className={classes.girMinText}>PAR 4 - 2 SHOTS</span>
                          <span className={classes.girMinText}>PAR 5 - 3 SHOTS</span>
                        </div>
                      </div>
                    </div>

                    <table>
                      <thead>
                        <tr className={classes.slateGrayRow}>
                          <th className={classes.playingPartner}>Playing partner</th>
                          <th>1</th>
                          <th>2</th>
                          <th>3</th>
                          <th>4</th>
                          <th>5</th>
                          <th>6</th>
                          <th>7</th>
                          <th>8</th>
                          <th>9</th>
                          <th className={classes.total}>TOTAL</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className={classes.playingPartnerRow}>
                          <td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className={classes.cuttingLine}/>

                  <div className={classes.rightSide}>

                    <div className='d-flex justify-content-center pt-3 pb-2'>
                      <StandaloneLogo className={classes.logo}/>
                    </div>

                    <p className={classes.targetsText}>Targets for Beating 36</p>

                    <div className='d-flex justify-content-between'>
                      <div className={classes.cell}>6</div>
                      <div className={classes.cell}>15</div>
                      <div className={classes.cell}>36</div>
                    </div>
                    <div className='d-flex justify-content-between py-1'>
                      <span>GREENS</span><span>PUTTS</span><span>SCORE</span>
                    </div>
                    <div className='d-flex justify-content-between'>
                      <div className={classes.cell}/>
                      <div className={classes.cell}/>
                      <div className={classes.cell}/>
                    </div>

                    <p className='my-2'>My strength for today was?</p>
                    <div className={classes.rectangle}/>

                    <p className='my-2'>To beat 36, I need to improve what area of my game?</p>
                    <div className={classes.rectangle}/>


                  </div>
                  <div className={classes.scissorsLeft}>
                    <ScissorsRegular/>
                  </div>

                  <div className={classes.scissorsRight}>
                    <ScissorsRegular/>
                  </div>
                </div>
              )
            })}
          </div>
          { printOptions?.doubleSided === true &&
            <div className='ScoreCardsPage'>
              <div className={classes.scorecardBack}>
                {[...userGroup].map(() => (
                  <>
                    <img src={scorecardsBack} alt='scorecard back' className={classes.backImage}></img>
                    <div className={classes.scissorsLeft}><ScissorsRegular/></div>
                    <div className={classes.scissorsRight}><ScissorsRegular/></div>
                    <div className={classes.cuttingLine}/>
                  </>
                ))}
              </div>
            </div>
          }
        </div>
      ))}
    </div>
  )
}

Scorecards.propTypes = {
  printOptions: PropTypes.shape({
    doubleSided: PropTypes.bool,
  }),
}

export default Scorecards
